import { Sectors } from '@centric-os/types';

export const SECTORS_LIST = [
  { text: Sectors.BON_APPETIT, value: Sectors.BON_APPETIT },
  { text: Sectors.CANTEEN, value: Sectors.CANTEEN },
  { text: Sectors.CHARTWELLS, value: Sectors.CHARTWELLS },
  { text: Sectors.CULINART, value: Sectors.CULINART },
  { text: Sectors.EUREST, value: Sectors.EUREST },
  { text: Sectors.FLIK, value: Sectors.FLIK },
  { text: Sectors.LEVY, value: Sectors.LEVY },
  { text: Sectors.MORRISON, value: Sectors.MORRISON },
  { text: Sectors.RESTAURANT_ASSOCIATES, value: Sectors.RESTAURANT_ASSOCIATES },
  { text: Sectors.WOLFGANG_PUCK, value: Sectors.WOLFGANG_PUCK },
];
